import { useState } from 'react';

import { useQueryParameter } from '@hotjar/webapp/hooks/useQueryParameter';

export interface RegisterQueryParams {
  campaignId?: string;
  signupMethod?: string;
  utmContent?: string;
  surveyTemplateId?: string;
  pricingTable?: string;
  logout?: boolean;
  ssoProvider?: string;
  authProvider?: string;
  ssoToken?: string;
}

export interface SignupMethodSettings {
  method: string;
  set: (method: string) => void;
}

export interface SignupStateParamsSettings {
  [name: string]: string;
}

export const useRegisterQueryParams = (): RegisterQueryParams => {
  const signupMethod = useQueryParameter('signup_method');
  const campaignId = useQueryParameter('c');
  const utmContent = useQueryParameter('utm_content');
  const surveyTemplateId = useQueryParameter('survey_template_id');
  const pricingTable = useQueryParameter('pricing_table');
  const logout = useQueryParameter('logout');
  // This is the param name for the provider when user uses SSO sign up button from insights sign up flow
  const ssoProvider = useQueryParameter('sso_provider');
  // This is the param name for the provider when user is redirected to SSO sign up from hotjar.com
  const authProvider = useQueryParameter('auth_provider');
  const ssoToken = useQueryParameter('ssotk');

  return {
    signupMethod,
    campaignId,
    utmContent,
    surveyTemplateId,
    pricingTable,
    logout: Boolean(logout),
    ssoProvider,
    authProvider,
    ssoToken,
  };
};

export const usePopulateStateParams = ({
  signupMethod,
}: {
  signupMethod: string;
}): SignupStateParamsSettings => {
  const queryParamsObj = useRegisterQueryParams();
  const stateParams: SignupStateParamsSettings = {};

  if (queryParamsObj.surveyTemplateId) {
    stateParams.survey_template_id = queryParamsObj.surveyTemplateId;
  }

  if (queryParamsObj.campaignId) {
    stateParams.c = queryParamsObj.campaignId;
  }

  if (signupMethod) {
    stateParams.signup_method = signupMethod;
  }

  return stateParams;
};

export const useSignupMethod = (): SignupMethodSettings => {
  const { signupMethod: signupMethodFromQuery } = useRegisterQueryParams();
  const [signupMethod, setSignupMethod] = useState(signupMethodFromQuery || '');

  return {
    method: signupMethod,
    set: setSignupMethod,
  };
};
